<div [chart]="humidityChart"></div>

